import config from "../../../../config";
import { getlist } from "../../../../contexts/apicontexts";

const normalizeString = (value) => String(value ?? "").trim();

const normalizeTaskItem = (item) => ({
  taskId: Number(item?.taskId ?? item?.TaskId ?? 0),
  title: normalizeString(item?.title ?? item?.Title),
  description: normalizeString(item?.description ?? item?.Description),
  status: normalizeString(item?.status ?? item?.Status),
  priority: normalizeString(item?.priority ?? item?.Priority),
  progressPercent: Number(item?.progressPercent ?? item?.ProgressPercent ?? 0),
  dueDate: normalizeString(item?.dueDate ?? item?.DueDate),
  assignedEmployeeName: normalizeString(item?.assignedEmployeeName ?? item?.AssignedEmployeeName),
  assignedEmployeeEmail: normalizeString(item?.assignedEmployeeEmail ?? item?.AssignedEmployeeEmail),
  createdAt: normalizeString(item?.createdAt ?? item?.CreatedAt),
  updatedAt: normalizeString(item?.updatedAt ?? item?.UpdatedAt),
});

const normalizeTicketTaskDetailsReport = (response) => ({
  ticketId: Number(response?.ticketId ?? response?.TicketId ?? 0),
  ticketNumber: normalizeString(response?.ticketNumber ?? response?.TicketNumber),
  ticketName: normalizeString(response?.ticketName ?? response?.TicketName),
  ticketStatus: normalizeString(response?.ticketStatus ?? response?.TicketStatus),
  openDate: normalizeString(response?.openDate ?? response?.OpenDate),
  organizationName: normalizeString(response?.organizationName ?? response?.OrganizationName),
  customerName: normalizeString(response?.customerName ?? response?.CustomerName),
  customerCode: normalizeString(response?.customerCode ?? response?.CustomerCode),
  customerUserName: normalizeString(response?.customerUserName ?? response?.CustomerUserName),
  customerUserEmail: normalizeString(response?.customerUserEmail ?? response?.CustomerUserEmail),
  employeeName: normalizeString(response?.employeeName ?? response?.EmployeeName),
  employeeEmail: normalizeString(response?.employeeEmail ?? response?.EmployeeEmail),
  taskCount: Number(response?.taskCount ?? response?.TaskCount ?? 0),
  tasks: Array.isArray(response?.tasks ?? response?.Tasks)
    ? (response?.tasks ?? response?.Tasks).map(normalizeTaskItem)
    : [],
});

export const fetchTicketTaskDetailsReport = async (ticketId) => {
  const response = await getlist(`${config.baseurl}TicketReport/ticket-task-details/${Number(ticketId || 0)}`);
  if (response?.status === 200) {
    return normalizeTicketTaskDetailsReport(response.data || {});
  }

  throw new Error(response?.message || "Ticket task details report could not be loaded.");
};
